import React, { useEffect, useState, ChangeEvent } from "react";
import {
  ProfileActive,
  ProfileNoActive,
  SetPasswordActive,
  SetPasswordNotActive,
} from "../../images-svg/IconProfile";
import ProfileForm from "./ProfileForm";
import SetPasswordForm from "./SetPasswordForm";
import {
  getUserProfile,
  UpdateUserProfile,
  UploadUserProfile,
  ViewImage,
} from "../../../api/user/User";
import { toast } from "react-toastify";
import { useLoading } from "../../../context/LoadingContext";
import { useAuth } from "../../../hook/use-auth";

interface MenuOptionType {
  id: number;
  value: string;
  iconAcitive: any;
  iconNotActive: any;
  isActive: boolean;
}

export interface ProfileFormType {
  id?: string;
  accountType?: string;
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  avatar?: string;
  verified?: boolean;
  enabled?: boolean;
  lastLogin?: string;
  extension: Extension;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}
export interface Extension {
  hotspot: HotSpotExtension;
}

export interface HotSpotExtension {
  organization: string;
  phone?: string;
  houseNumber?: string;
  street?: string;
  subDistrict?: string;
  district?: string;
  province?: string;
  zipCode?: string;
  imageId?: string;
}

export interface FileImageList {
  files: FileImage[];
}
export interface FileImage {
  id: string;
  name: string;
  type: string;
  size: number;
  path: string;
  auth_required: boolean;
  links: Link[];
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface Link {
  href: string;
  rel: string;
  type: string;
  title: string;
}

function Profile() {
  const [menuOptions, setMenuOptions] = useState<MenuOptionType[]>([
    {
      id: 1,
      value: "ทั่วไป",
      iconAcitive: ProfileActive,
      iconNotActive: ProfileNoActive,
      isActive: true,
    },
    {
      id: 2,
      value: "เปลี่ยนรหัสผ่าน",
      iconAcitive: SetPasswordActive,
      iconNotActive: SetPasswordNotActive,
      isActive: false,
    },
  ]);
  const [activeMenuId, setActiveMenuId] = useState(1);

  const { user, initAuth } = useAuth();
  // const [user, setUser] = useState<ProfileFormType>();

  const [isSubmitForm, setIsSubmitForm] = useState(false);
  const handleClickMenuOption = (id: number) => {
    const updatedOptions = menuOptions.map((option) => ({
      ...option,
      isActive: option.id === id,
    }));
    setMenuOptions(updatedOptions);
    setActiveMenuId(id);
  };
  const { onSetLoading } = useLoading();

  const userProfile = async () => {
    try {
      onSetLoading(true);
      const data: ProfileFormType = (await getUserProfile()) as ProfileFormType;
      if (data) {
        initAuth(data);
        let user = {
          id: data.id,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          role: data.role,
        };
        let userJson = JSON.stringify(user);
        localStorage.setItem("user", userJson);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };

  const handleUpdateProfileInfo = async (fileId: string) => {
    try {
      onSetLoading(true);
      if (user) {
        let rawUser: ProfileFormType = { ...user };
        rawUser.avatar = ViewImage(fileId);

        await UpdateUserProfile(rawUser);

        toast.success("อัพโหลดรูปภาพสำเร็จ", {
          position: "bottom-left",
          autoClose: 3000,
        });
        initAuth(rawUser);
      }
      onSetLoading(false);
    } catch (error) {
      onSetLoading(false);
      console.log(error);
    }
  };

  const handleUploadImage = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg"
      ) {
        try {
          onSetLoading(true);
          let payload = {
            files: file,
          };
          const { files } = (await UploadUserProfile(payload)) as FileImageList;
          if (files.length > 0) {
            handleUpdateProfileInfo(files[0].id);
          }
          onSetLoading(false);
        } catch (error) {
          onSetLoading(false);
          console.log(error);
        }
      } else {
        toast.error("กรุณาอัพโหลดไฟล์ที่นามสกุล .png .jpeg or .jpg", {
          position: "bottom-left",
          autoClose: 3000,
        });
      }
    }
  };

  useEffect(() => {
    userProfile();
  }, []);

  useEffect(() => {
    if (isSubmitForm) {
      userProfile();
      setIsSubmitForm(false);
    }
  }, [isSubmitForm]);

  return (
    <div className="mt-6 flex flex-col gap-8">
      <div className="inline-flex gap-6 items-start">
        {menuOptions.map((menu) => (
          <button
            onClick={() => handleClickMenuOption(menu.id)}
            key={menu.id}
            className={`flex items-center py-2 ${
              menu.isActive && "border-b-[2px] border-primary-main"
            } gap-2`}
          >
            {menu.isActive ? <menu.iconAcitive /> : <menu.iconNotActive />}
            <p
              className={`${
                menu.isActive ? "text-text-primary" : "text-gray-6"
              } text-sm font-normal`}
            >
              {menu.value}
            </p>
          </button>
        ))}
      </div>
      {activeMenuId === 1 ? (
        <div className="flex flex-col md:flex-row gap-6 justify-start md:justify-between">
          <div className=" min-w-[200px] h-fit items-center inline-flex flex-col py-8 px-6 gap-6 shadow-z8 rounded-3xl bg-primary-contrast">
            <div className="w-[140px] h-[140px] rounded-full border-[1px] border-dashed border-primary-main p-2">
              <div className="relative">
                <img
                  className="w-[122px] h-[122px] rounded-full object-fill"
                  src={`${
                    user?.avatar ? user?.avatar : "/images/profile-user.svg"
                  }`}
                  alt="profile-user"
                  width={140}
                  height={140}
                />
                <div className="bg-black bg-opacity-70 opacity-0 hover:opacity-100 w-[122px] h-[122px] absolute top-0 rounded-full flex flex-col justify-center">
                  <label
                    htmlFor="file-input"
                    className="flex flex-col items-center cursor-pointer "
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 8.45645C1 6.27136 2.77136 4.5 4.95645 4.5V4.5C5.58953 4.5 6.16169 4.12272 6.41107 3.54083L6.72075 2.81824C7.19349 1.71519 8.2781 1 9.47819 1H11H12.5218C13.7219 1 14.8065 1.71519 15.2792 2.81824L15.5889 3.54083C15.8383 4.12272 16.4105 4.5 17.0435 4.5V4.5C19.2286 4.5 21 6.27136 21 8.45645V13.5C21 16.2614 18.7614 18.5 16 18.5H6C3.23858 18.5 1 16.2614 1 13.5V8.45645Z"
                        stroke="white"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="3"
                        cy="3"
                        r="3"
                        transform="matrix(-1 0 0 1 14 7.5)"
                        stroke="white"
                        strokeWidth="1.5"
                      />
                    </svg>
                    <p className="text-sm font-normal text-primary-contrast">
                      อัปเดตรูปภาพ
                    </p>
                  </label>
                  <input
                    id="file-input"
                    type={"file"}
                    accept=".png, .jpg, .jpeg"
                    multiple={false}
                    className={"max-w-[122px] hidden"}
                    onChange={handleUploadImage}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center ">
              <p className="text-text-primary text-base font-medium leading-6 whitespace-pre ">
                {`${user?.firstName} ${user?.lastName}`}
              </p>
              <p className="text-text-secondary text-sm font-normal leading-6">
                {`${user?.email}`}
              </p>
            </div>
          </div>
          <div className="w-full p-6 rounded-[32px] bg-primary-contrast shadow-z8">
            <ProfileForm user={user} isSubmit={setIsSubmitForm} />
          </div>
        </div>
      ) : (
        activeMenuId === 2 && (
          <div className="w-full h-fit p-6 bg-primary-contrast shadow-z8 rounded-[32px]">
            <SetPasswordForm />
          </div>
        )
      )}
    </div>
  );
}

export default Profile;
